import React from 'react';
import { Tag } from 'ui';
import { useIntl } from 'react-intl';

interface FilterTagProps {
  key: string;
  filterKey: string;
  value: any;
  onClose: (key: string) => void;
  isLabelVisible?: boolean;
  labelPrefix?: string;
  enumPrefixes?: Record<string, string>;
}

const FilterTag = ({
  key,
  filterKey,
  value,
  onClose,
  isLabelVisible = false,
  labelPrefix = 'filter',
  enumPrefixes,
}: FilterTagProps) => {
  const intl = useIntl();

  const getEnumLabel = (enumName: string, v: any) =>
    intl.formatMessage({
      id: `${labelPrefix.replace(/\.filters$/, '')}.enums.${enumName}.${String(v)}`,
      defaultMessage: String(v),
    });

  const getFieldLabel = (k: string) =>
    intl.formatMessage({
      id: `${labelPrefix}.${k}`,
      defaultMessage: k,
    });

  const getLabel = () => {
    switch (filterKey) {
      case 'page_category':
        return intl.formatMessage({ id: String(value) });

      case 'search':
        return isLabelVisible ? `${getFieldLabel(filterKey)}: ${value}` : value;

      case 'status': {
        const enumName = enumPrefixes?.[filterKey];
        if (enumName) return getEnumLabel(enumName, value);
        return intl.formatMessage({ id: String(value) });
      }
      case 'public':
        return value === '1' || value === 1 || value === true
          ? intl.formatMessage({ id: 'general.yes' })
          : intl.formatMessage({ id: 'general.no' });
      case 'emarket':
        return value
          ? intl.formatMessage({ id: 'products.visible' })
          : intl.formatMessage({ id: 'products.hidden' });
      default: {
        if (
          typeof value === 'boolean' ||
          value === 'true' ||
          value === 'false'
        ) {
          const isTrue = value === true || value === 'true';
          return intl.formatMessage({
            id: isTrue ? 'general.yes' : 'general.no',
          });
        }
        const enumName = enumPrefixes?.[filterKey];
        if (enumName) return getEnumLabel(enumName, value);
        return isLabelVisible ? `${getFieldLabel(filterKey)}: ${value}` : value;
      }
    }
  };

  return (
    <Tag key={key} closable bordered={false} onClose={() => onClose(filterKey)}>
      {getLabel()}
    </Tag>
  );
};

export default FilterTag;
